import { APP_URL } from '@vaultsfyi/common'

export function getOpportunityRedirectLink({ network, address }: { network: string; address: string }) {
  return `${APP_URL}/opportunity/${network}/${address}`
}
